import { render } from "./TicketsManager.vue?vue&type=template&id=74ee2a36"
import script from "./TicketsManager.vue?vue&type=script&lang=js"
export * from "./TicketsManager.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__